@if (form) {
  <form [formGroup]="form">
    @if (loaded) {
      <se-fe-form-field
    [seFeDataConfig]="{
        label: seFeDataLabel,
        required: isRequired,
        errorMessages: {
          required: 'SE_PO_UI_STATE_SELECT.ERRORS.required' | translate
        }
      }">
      <se-fe-form-field-select
        [formControlName]="ngControl.name"
        sePoAriaValidity
        [seFeDataOptions]="stateOptions"
        [seFeDataAllowClear]="true"
        [seFeDataComfy]="true">
      </se-fe-form-field-select>
    </se-fe-form-field>
  }
</form>
}
